import dynamic from 'next/dynamic';
import { ProvidersSkeleton } from './providers-skeleton';

export const DynamicProvidersSection = dynamic(
  async () => import('./providers-section').then((m) => m.ProvidersSection),
  {
    ssr: false,
    loading: () => <ProvidersSkeleton />,
  }
);
